import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import withWidth from '@material-ui/core/withWidth';
import FolderIcon from '@material-ui/icons/Folder';
import React, { Fragment, useEffect, useState } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { OldPostMutiFormData } from '../../core/controls/helpers/requests';
import { getEnvVariable } from '../../modules/environmentalList';
import AttachmentsS3Form from './forms/attachments';
import ImagesS3Form from './forms/images';
import Dropdown from '../../core/controls/components/dropdown';
import { AppBar, IconButton, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { Close, Save } from '@material-ui/icons';
import DefaultSettings from '../../core/controls/components/settings';

const UploadImageToS3WithNativeSdk = (props) => {
    const [selectedFile, setSelectedFile] = useState([]);
    const [attachmentDetails, setAttachmentDetails] = useState([]);
    const [fileProgress, setFileProgress] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [NoteView, setNoteView] = useState(props.dataItem || [])
    const [reload, setReload] = useState(false)
    const [errorObj, setErrorObj] = useState(props.errors || {})
    const [hideSave, setHideSave] = useState(false);
    const [attachmentName, setAttachmentName] = useState('');
    const [imageTypeName, setImageTypeName] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedAttachId, setSelectedAttachId] = useState('');
    const [selectedImageId, setSelectedImageId] = useState('');
    const params = useParams()


    const handleFileInput = (e) => {
        setSelectedFile(e.target.files);
    }

    useEffect(() => {
        if (props && props.errors && Object.keys(props.errors).length > 0) {
            setErrorObj(props.errors)
            setUploadedFiles([])
            setAttachmentDetails([])
        }
    }, [props && props.errors])

    const uuidv4 = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    const validatetType = () => {
        if (!(selectedFile && selectedFile.length > 0 && (attachmentName || imageTypeName))) {
            return false;
        }
        return true;
    }

    const handleUpload = (files, uploadType) => {
        if (validatetType()) {
            uploadFile(files);
        } else {
            if (DefaultSettings.getAlert() != null) {
                if (uploadType === 'I' )
                    DefaultSettings.getAlert().show('Please select ImageType', 'error');
                else if (uploadType !== 'I' )
                    DefaultSettings.getAlert().show('Please select AttachmentType', 'error');

            }
            console.error("AttachmentId validation failed.");
        }
    }
    const uploadFile = (files) => {
        let obj = Object.values(errorObj || {});
        let saveData = errorObj && Object.keys(errorObj).length > 0 && obj.some(each => each && each.error === true)
        if (!saveData) {
            if (files && files.length > 0) {
                uploadFileWrapper(files, NoteView);
            }
        }
    }

    const uploadFileWrapper = (files, info) => {
        let url = getEnvVariable('Sidebar') + `/api/FileSystem/${props.refid ? props.refid + '/Upload' : 'Upload'}?parentid=${props.refid}&sitePermitTypeId=${params.routeid}&attachmentType=${props.selectedAttachName || attachmentName}`;
        let predetails = []
        var formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i], files[i].name);
        }
        OldPostMutiFormData(url, formData, true, true, '').then(response => {
            let res = response
            if (res && res.length > 0)
                for (let i = 0; i < res.length; i++) {
                    predetails.push({
                        ...info[i], FileName: res[i].fileName, ContentType: res[i].fileName.split(".").pop(), Size: res[i].size, FileReference: res[i].fileReference,
                        fileName: res[i].fileName, extension: files[i].type, fileType: files[i].type, guid: res[i].fileReference, size: res[i].size,

                    });
                }
            setAttachmentDetails(predetails);
            ParentCallBack(predetails)
        }).catch(ex => {
            console.error(ex)
        })
    }

    const ParentCallBack = (predetails) => {
        if (props.handleUploads) {
            props.handleUploads(predetails);
            if (!props.customclose) {
                handleDialogCloseFromProps();
                setSelectedFile([])
            }
        }
    }

    const getFileTypes = (type) => {
        switch (type) {
            case 'I': return ".jpg, .jpeg, .png"
            case 'A': return getEnvVariable('AttachmentExtensions')
            default: return getEnvVariable('AttachmentExtensions') + ".jpg, .jpeg, .png"
        }
    }

    const handleAttachmentname = (val) => {
        setAttachmentName(val)
    }

    const handleDialogClose = () => {
        //setNoteView(null)
        if (!props.customclose)
            setOpenDialog(false)
    }
    const handleDialogCloseFromProps = () => {
      if (props.handleClose)
            props.handleClose()
        else
            setSelectedFile([])
        setNoteView(null)
        setSelectedAttachId(null);
        setSelectedImageId(null);
        setAttachmentName(null);

        setOpenDialog(false)
    }

    return <div className="col-3 pl-0">
        {reload}
        {selectedFile && selectedFile.length === 0 && <Fragment><input
            type="file"
            name="file"
            accept={getFileTypes(props.uploadType)}
            multiple={props.multiple || false}
            id="file-upload"
            onChange={handleFileInput}
            style={{ display: "none" }}
        />
            <label htmlFor="file-upload">
                <Button style={{
                    backgroundColor: '#3f51b5', border: '2px solid #3f51b5', padding: '5px', borderRadius: '5px', fontWeight: 'bold', color: 'white'
                }} className=' mt-2' size="small" color="primary" aria-label="add" title="Upload" component="span">{props.title}</Button>
            </label>
        </Fragment>}
        {selectedFile && selectedFile.length > 0 && <Dialog onClose={() => { handleDialogCloseFromProps(); }} aria-labelledby="customized-dialog-title"
            open={true} fullWidth={true} maxWidth={'lg'} >
            <MuiDialogTitle style={{ padding: 2 }} id="customized-dialog-title" onClose={() => { handleDialogCloseFromProps(); }}>
                <AppBar position="static" color="primary" elevation={0}>
                    <Toolbar variant='dense'>
                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid item xs={9}>
                                <Typography variant="h6">{props.uploadType === "I" ? 'Image Details' : 'Attachment Details'}</Typography>
                            </Grid>

                            <Grid item xs={3} style={{ textAlign: 'right' }}>
                                {<IconButton size='small' onClick={() => {
                                    handleUpload(selectedFile, props.uploadType);
                                    //handleDialogClose();
                                }} color="primary"
                                    disabled={hideSave === true ? true : false}>
                                    <Save fontSize='small' color='secondary' /> <Typography variant="caption" color="primary" style={{ px: '4px' }}>Save</Typography>
                                </IconButton>}
                                <IconButton className="ms-1" size='small' onClick={() => { handleDialogCloseFromProps(); }} color="primary">
                                    <Close fontSize='small' color='secondary' /> <Typography variant="caption" color="primary" style={{ px: '4px' }}>Close</Typography>
                                </IconButton>

                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </MuiDialogTitle>
            {selectedFile && selectedFile.length > 0 && <MuiDialogContent dividers style={{ height: window.innerHeight - 300, overflow: 'auto', padding: 2 }}>
                <div className='col-12 px-2'>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item xs={9}>
                            <div className='pb-3'>
                                {props.uploadType === "I" ?
                                    <Dropdown label='Image Type' className="col-4 m-1" name="ImageTypeId"
                                    required={true}
                                    error={errorObj['ImageTypeId'] && errorObj['ImageTypeId'].error}
                                        items={props.imagelist}
                                        extraprops={{
                                            transformProps: {
                                                'label': 'Name',
                                                'value': 'Value'
                                            }
                                        }} value={props.selectedImageId}
                                        fullWidth={true}
                                        handleFieldValue={(evt) => {
                                            setSelectedImageId(evt.target.value);
                                            props.handleImageId(evt.target.value);
                                            setImageTypeName((props.imagelist.find(each => { return each.Id.toString() === evt.target.value.toString() }) || {}).Name)
                                        }} />
                                    : <Dropdown
                                        required={true}
                                        error={errorObj['AttachmentId'] && errorObj['AttachmentId'].error}
                                        label='Attachment Type'
                                        name="AttachmentId"
                                        className="col-8"
                                        fullWidth={true}
                                        items={props.attachmentlist}
                                        extraprops={{
                                            transformProps: {
                                                'label': 'Name',
                                                'value': 'Value'
                                            }
                                        }}
                                        value={selectedAttachId}
                                        handleFieldValue={(evt) => {
                                            setSelectedAttachId(evt.target.value);
                                            props.handleAttachmentId(evt.target.value);
                                            setAttachmentName((props.attachmentlist.find(each => { return each.Id.toString() === evt.target.value.toString() }) || {}).Name);
                                        }}
                                    />}
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item >
                        {!props.isCustom && props.uploadType === "I" && <ImagesS3Form {...props} selectedFile={selectedFile} fileProgress={fileProgress} NoteView={NoteView} currentUser={props.currentUser} validations={props.validations}
                            errorObj={errorObj}
                            handleHideSave={(val) => { setHideSave(val) }}
                            handleFieldValue={(obj) => { setNoteView(obj.data); setErrorObj(obj.error); setReload(!reload) }} />}
                        {!props.isCustom && props.uploadType === "A" && <AttachmentsS3Form {...props} selectedFile={selectedFile} fileProgress={fileProgress} NoteView={NoteView} validations={props.validations}
                            errorObj={errorObj} handleFieldValue={(obj) => { setNoteView(obj.data); setErrorObj(obj.error); setReload(!reload) }}
                            setAttachmentName={(val) => { handleAttachmentname(val) }} attachmentlist={props.attachmentlist} />}
                        {props.isCustom && <ListItem className='col-12'>
                            <ListItemIcon> <FolderIcon /> </ListItemIcon>
                            <ListItemText className='col-6'
                                primary={selectedFile[0].name}
                                secondary={<small className='text-primary'>{"Size: " + (selectedFile[0].size / 1048576).toFixed(2) + " MB"}
                                    {Array.isArray(fileProgress) && fileProgress.length > 0 && ' Progress %:' + fileProgress[0].progress}</small>}
                            />
                        </ListItem>}
                    </Grid>
                </div>
            </MuiDialogContent>}
            {/* <MuiDialogActions>
                <Button className='col-6' autoFocus onClick={() => { handleDialogClose(); props.handleClose ? props.handleClose() : setSelectedFile([]) }} color="primary">
                    Close
                </Button>
                {selectedFile && selectedFile.length > 0 && attachmentName && <Button className='col-6'
                    disabled={hideSave === true ? true : false} autoFocus onClick={() => { uploadFile(selectedFile); handleDialogClose(); }} color="primary">
                    Upload
                </Button>}
            </MuiDialogActions> */}
        </Dialog>}
    </div>
}

export default withWidth()(withRouter(UploadImageToS3WithNativeSdk));